<section id="como-llegar" class="section">
    <h2>¡Aquí nos encuentras!</h2>
    <iframe
        title="ecoturismo base Google Map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3123.2955497682315!2d-71.54212684836187!3d-38.48082168017957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x966ccb47271c8b8b%3A0xa01af27f520a495e!2sEcoturismo%20BASE!5e0!3m2!1ses-419!2scl!4v1635483574440!5m2!1ses-419!2scl"
        width="100%"
        height="600"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
    />
</section>

<style lang="scss">
    h2 {
        text-align: center;
    }
</style>
